import axiosInstance from '../axiosInterceptor/axiosInstance'

// What a game on this court and tier would be allowed to feed its scoreboard from —
// asked before the game exists, because a court alone cannot answer it (Studio also depends on
// the tier and on the org's manual-scoreboard rollout). A saved event reports the same list as
// broadcast.supportedScoreboardSources.
const getScoreboardSources = (orgId, { courtId, streamType }) =>
  axiosInstance
    .get(`v1/orgs/${orgId}/games/scoreboard-sources`, {
      params: { courtId, streamType },
      skipErrorNotification: true,
    })
    .then((r) => r.data?.supportedSources || [])

export default getScoreboardSources
